import { Breakpoint, useTheme } from '@mui/material/styles';

import useMediaQuery from '@mui/material/useMediaQuery';

export function useBreakpoints() {
  const theme = useTheme();
  return {
    useDown: (key: Breakpoint | number) =>
      useMediaQuery(theme.breakpoints.down(key)),
    useUp: (key: Breakpoint | number) =>
      useMediaQuery(theme.breakpoints.up(key)),
    useNot: (key: Breakpoint) => useMediaQuery(theme.breakpoints.not(key)),
    useBetween: (start: Breakpoint | number, end: Breakpoint | number) =>
      useMediaQuery(theme.breakpoints.between(start, end)),
    useOnly: (key: Breakpoint) => useMediaQuery(theme.breakpoints.only(key)),
    isMobileDevice: useMediaQuery(theme.breakpoints.only('xs')),
  };
}
